import { NaniumObject, Type } from "nanium/objects";

export class FieldOfStudy extends NaniumObject<FieldOfStudy> {
	@Type(String) name?: string;
	@Type(String) comment?: string;
	@Type(String) id?: string;
	@Type(String) studyField?: string;
	@Type(String) abbr?: string;
	@Type(String) nameGerman?: string;
	@Type(String) nameShortGerman?: string;
	@Type(String) degreeShort?: string;

}

export class Equivalence extends NaniumObject<Equivalence> {
	@Type(String) name?: string;
	@Type(String) nameGerman?: string;
	@Type(String) comment?: string;
	@Type(String) id?: string;

}

export class Degree extends NaniumObject<Degree> {
	@Type(String) name?: string;
	@Type(String) nameGerman?: string;
	@Type(String) abbr?: string;
	@Type(String) id?: string;
	@Type(String) comment?: string;
	@Type(String) degreeClass?: string;
	@Type(String) studiesDescription?: string;
}

export class ProgramOption extends NaniumObject<ProgramOption> {
	@Type(String) name?: string;
	@Type(String) id?: string;
}

export class DegreeOption extends NaniumObject<DegreeOption> {
	@Type(String) name?: string;
	@Type(String) id?: string;
	@Type(Array, ProgramOption) programs?: ProgramOption[];
}

export class DegreeTypes extends NaniumObject<DegreeTypes> {
	@Type(Degree) degree?: Degree;
	@Type(Array, Equivalence) equivalence?: Equivalence[];
	@Type(Array, FieldOfStudy) programs?: FieldOfStudy[];
}




